var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cls},[_c('input',{ref:"inputRef",class:_vm.cls2,attrs:{"type":"text","placeholder":_vm.holderNm},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"blur":_vm.handlerBlur}}),_c('div',{class:_vm.cls3},[_vm._v("자")])])
}
var staticRenderFns = []

export { render, staticRenderFns }